import { useState } from "react";
import { createContext } from "react";

export const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const [isAuth, setisAuth] = useState(
    JSON.parse(localStorage.getItem("goodfoodisAuth") || true)
  );
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState(
    JSON.parse(localStorage.getItem("goodFoodUser"))
  );
  const [query, setqueery] = useState("");

  const Login = () => {
    localStorage.setItem("goodfoodisAuth", false);
    setisAuth(false);
  };

  const Logout = () => {
    localStorage.setItem("goodfoodisAuth", true);
    setisAuth(true);
  };

  const setProduct = (data) => {
    setCart([...cart, data]);
  };

  const setAfterDelete = (data) => {
    setCart(data);
  };

  const setQueerydata = (data) => {
    setqueery(data);
  };

  const value = {
    isAuth,
    cart,
    total,
    Login,
    Logout,
    setProduct,
    setTotal,
    setAfterDelete,
    setUsers,
    users,
    setQueerydata,
    query,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
